// Entry point for the build script in your package.json

import * as bootstrap from "bootstrap"
import Rails from "@rails/ujs"
import $ from "jquery"

// Start Rails UJS for handling data-confirm and data-method
Rails.start()

import "./generic"
import "../views/admin/item_transactions/item_transactions"
import "../views/admin/items/items"
import "../views/admin/users/user_all_systems"
import "../views/admin/users/user_company"
import "../views/admin/systems/systems_config"
import "../views/admin/mit_license_details/reports"
import "../views/system_configs/interface-blocks"
import "../views/page/kickstart_poll"
